<mat-stepper #stepper [linear]="isLinear">
  <mat-step>
    <ng-template matStepLabel>Instructions</ng-template>
    <ng-container>
      <app-instruction></app-instruction>
      <div style="margin-top: 20px; display: flex; justify-content: end;" >
        <button mat-button (click)="nextStep1()">Next</button>
      </div>
    </ng-container>
  </mat-step>
  <mat-step  *ngFor="let item of navItems; let i = index" [color]="someCondition[i] ? 'warn' : 'primary'">
    <ng-template matStepLabel>{{item.displayName}}</ng-template>
    <ng-container *ngIf="item.displayName === 'Personal Details'">
        <app-personal-data-entry #personalDataEntry (dataEvent)="receiveDataPersonal($event)" (dataRemarks)="persoanlDataRemarks($event)"></app-personal-data-entry>
        <div style="margin-top: 20px; display: flex; justify-content: end;" >
          <button mat-button (click)="nextStepPersonal()" [disabled]="personalNextDisable">Next</button>
        </div>
    </ng-container>
    <ng-container *ngIf="item.displayName !== 'Personal Details' && item.displayName !== 'Authorization'">
        <ng-container *ngIf="selectedStep === i || (i < selectedStep)">
          <ng-container *ngIf="item.children?.length > 1; else otherChild">
            <ng-container *ngFor="let child of item.children">
              <app-component-data-entry [item]="child" #componentDataEntry (dataEvent)="receiveData($event)" (respData)="respData($event)"></app-component-data-entry>
            </ng-container>
          </ng-container>
          <ng-template #otherChild>
            <app-component-data-entry [item]="item" #componentDataEntry (dataEvent)="receiveData($event)" (respData)="respData($event)" (compDataRemarks)="compDataRemarks($event)"></app-component-data-entry>
          </ng-template>
          <div style="margin-top: 20px; display: flex; justify-content: end;" >
            <button mat-button (click)="prevStep()">Prev</button>
            <button mat-button (click)="nextStepComp()" [disabled]="!compNextDisable || (selectedStep > stepCompleted)">Next</button>
          </div>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="item.displayName === 'Authorization' && selectedStep === i">
      <app-authorization-comp></app-authorization-comp>
      <div style="margin-top: 20px; display: flex; justify-content: end;" >
        <button mat-button (click)="prevStep()">Prev</button>
      </div>
    </ng-container>
  </mat-step>
</mat-stepper>
 


<!-- [ngClass]="someCondition ? 'custom-color' : 'default-color' " -->